import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoPrev = () => {
  return (
    <g>
      <path d="m14.54.2313a.7509.7509 0 0 0 -.75 0l-12.33 7.1187a.75.75 0 0 0 0 1.2988l12.33 7.1191a.75.75 0 0 0 1.125-.6494v-14.2378a.7487.7487 0 0 0 -.375-.6494zm-1.125 13.5887-10.08-5.82 10.08-5.82z" />
    </g>
  );
};

export default withIcon(IconVideoPrev);
